export const FacebookIcon = () => (
  <svg className='h-6 w-6 pr-1' fill='currentColor' viewBox='0 0 24 24' aria-hidden='true'>
    <path
      fillRule='evenodd'
      d='M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z'
      clipRule='evenodd'
    ></path>
  </svg>
);

export const SpotifyIcon = () => (
  <svg className='h-5 w-5 pr-1' fill='currentColor' viewBox='0 0 24 24' aria-hidden='true'>
    <path d='M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.66 0 12 0zm5.521 17.34c-.24.36-.66.48-1.02.24-2.82-1.74-6.36-2.1-10.56-1.14-.42.12-.78-.18-.9-.54-.12-.42.18-.78.54-.9 4.56-1.02 8.52-.6 11.64 1.32.42.18.48.66.3 1.02zm1.44-3.3c-.3.42-.84.6-1.26.3-3.24-1.98-8.16-2.58-11.94-1.44-.48.12-1.02-.12-1.14-.6-.12-.48.12-1.02.6-1.14 4.32-1.26 9.72-.6 13.44 1.68.42.18.6.78.3 1.2zm.12-3.36c-3.9-2.34-10.32-2.52-14.04-1.38-.6.18-1.2-.18-1.38-.72-.18-.6.18-1.2.72-1.38 4.2-1.26 11.16-1.02 15.66 1.62.54.3.72 1.02.42 1.56-.3.48-1.02.66-1.56.36z'></path>
  </svg>
);

export const YouTubeIcon = () => (
  <svg className='h-6 w-6 pr-1' fill='currentColor' viewBox='0 0 24 24' aria-hidden='true'>
    <path
      fillRule='evenodd'
      d='M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.376.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.376-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z'
      clipRule='evenodd'
    ></path>
  </svg>
);

export const AppleIcon = () => (
  <svg className='h-6 w-6 pr-1' fill='currentColor' viewBox='0 0 24 24' aria-hidden='true'>
    <g>
      <path
        fillRule='evenodd'
        d='M21.1,8.1L21.1,8.1L21.1,8.1L21.1,8.1L21.1,8.1L21.1,8.1l-0.4,0.4c-0.3,0.2-0.5,0.4-0.8,0.7
		c-0.2,0.2-0.4,0.5-0.6,0.7c-0.2,0.3-0.3,0.5-0.4,0.8c-0.1,0.3-0.2,0.5-0.2,0.8c-0.1,0.3-0.1,0.7-0.1,1.1s0,0.9,0.1,1.2
		s0.2,0.6,0.3,0.9c0.1,0.3,0.3,0.6,0.4,0.8c0.2,0.3,0.3,0.5,0.5,0.7c0.2,0.2,0.4,0.4,0.6,0.5c0.2,0.2,0.4,0.3,0.7,0.5
		c0.3,0.2,0.4,0.2,0.4,0.2l0,0l0,0l0,0l0,0l0,0v0v0l-0.3,0.8c-0.2,0.5-0.4,1-0.7,1.4c-0.2,0.4-0.5,0.9-0.8,1.3
		c-0.3,0.4-0.6,0.8-0.8,1.1c-0.2,0.3-0.5,0.5-0.7,0.7c-0.2,0.2-0.4,0.4-0.6,0.5c-0.2,0.1-0.4,0.2-0.7,0.3s-0.4,0.1-0.4,0.1l-0.1,0
		l0,0l0,0l-0.2,0c-0.1,0-0.3,0-0.6-0.1c-0.3,0-0.7-0.2-1.2-0.4c-0.5-0.2-0.9-0.3-1.2-0.4c-0.3-0.1-0.6-0.1-0.9-0.1s-0.6,0-0.9,0.1
		s-0.6,0.2-1.1,0.3s-0.9,0.3-1.2,0.4L8.9,24l-0.1,0l-0.1,0v0v0H8.5H8.2v0v0l-0.1,0L8,24l0,0c0,0-0.1,0-0.2,0c-0.1,0-0.2-0.1-0.4-0.2
		S7,23.5,6.7,23.3c-0.2-0.2-0.5-0.4-0.7-0.6s-0.5-0.6-0.8-1c-0.3-0.5-0.6-0.9-0.9-1.3c-0.2-0.4-0.5-0.8-0.7-1.3
		c-0.2-0.5-0.4-1-0.6-1.5s-0.3-1-0.5-1.6c-0.1-0.5-0.2-1.1-0.3-1.7l-0.1-0.9V13v-0.5h0h0l0.1-0.6c0-0.4,0.1-0.8,0.2-1.2
		s0.2-0.7,0.4-1C3,9.3,3.2,9,3.3,8.7c0.2-0.3,0.4-0.5,0.5-0.8c0.2-0.2,0.4-0.4,0.6-0.6C4.7,7.1,4.9,7,5.2,6.8
		c0.3-0.2,0.6-0.4,0.9-0.5C6.5,6.1,6.8,6,7.1,6c0.3-0.1,0.7-0.1,1-0.1s0.8,0,1.1,0.1c0.4,0.1,0.9,0.3,1.5,0.5c0.6,0.2,0.9,0.3,1,0.4
		c0.1,0,0.2,0,0.4,0c0.1,0,0.6-0.2,1.5-0.4c0.8-0.3,1.4-0.5,1.7-0.5s0.7-0.1,1-0.1c0.4,0,0.8,0,1.2,0.1c0.4,0.1,0.8,0.2,1,0.3
		c0.3,0.1,0.6,0.2,0.8,0.4c0.3,0.1,0.5,0.3,0.7,0.5c0.2,0.2,0.4,0.4,0.6,0.6S21.1,8.1,21.1,8.1C21.1,8.1,21.1,8.1,21.1,8.1z'
        clipRule='evenodd'
      ></path>
      <path
        id='svg_2'
        fillRule='evenodd'
        d='M16.6,0L16.6,0L16.6,0l0.2,0l0,0.1c0,0.1,0,0.3,0,0.6s-0.1,0.6-0.1,0.9s-0.2,0.5-0.3,0.8
		S16.1,3,15.9,3.3S15.6,3.8,15.4,4c-0.2,0.2-0.4,0.4-0.7,0.6C14.5,4.8,14.2,5,14,5.1c-0.2,0.1-0.5,0.2-0.8,0.3
		c-0.3,0.1-0.6,0.1-0.8,0.1l-0.4,0L12,5c0-0.4,0.1-0.7,0.1-1s0.2-0.6,0.3-0.8c0.1-0.3,0.3-0.5,0.4-0.8c0.2-0.2,0.3-0.5,0.5-0.7
		c0.2-0.2,0.4-0.4,0.6-0.6c0.2-0.2,0.5-0.3,0.8-0.5c0.3-0.1,0.6-0.3,0.9-0.4s0.5-0.2,0.7-0.2S16.6,0,16.6,0z'
        clipRule='evenodd'
      ></path>
    </g>
  </svg>
);

export const TennistalkerIcon = () => (
  <svg xmlns='http://www.w3.org/2000/svg' width='50' height='40' viewBox='0 0 50 40' fill='none'>
    <path
      d='M27.6722 4.67932L0 11.5677V21.6627L7.60095 19.5249V29.9762C10.2613 27.3159 16.7854 22.5336 19.715 20.475V16.5558L27.6722 14.2993V4.67932Z'
      fill='currentColor'
    />
    <path
      d='M19.715 36.0332V24.5131C14.2043 29.7387 9.34284 35.6374 7.60095 37.9335V39.1211L19.715 36.0332Z'
      fill='currentColor'
    />
    <path
      d='M22.3278 35.3206V25.5819L30.285 23.4442V16.9121C35.3206 13.6817 40.38 11.4489 42.2802 10.7363V20.5938L50 18.5748V28.5511L22.3278 35.3206Z'
      fill='currentColor'
    />
    <path
      d='M30.285 13.5867V3.96673L42.2803 0.878845V8.71732C35.2732 10.9739 30.285 13.5867 30.285 13.5867Z'
      fill='currentColor'
    />
  </svg>
);
